<template>
  <div class="wrapper__error">
    <h2>
      Page not found! Maybe view our
      <router-link to="/characters">home</router-link>
    </h2>
  </div>
</template>

<style scoped lang="scss">
.wrapper__error {
  width: 100%;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
}
</style>
